import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📘 6 Bände DER REHA-CODE 360° (60 Seiten Kerninhalt)',
  price: '€27'
}, {
  label: '🎁 Boni #1: Das Load-Master Protokoll (20 Seiten)',
  price: 'KOSTENLOSE'
}, {
  label: '🎁 Boni #2: Das A.R.M.A. Präventions-Schild (20 Seiten)',
  price: 'KOSTENLOSE'
}, {
  label: '🎁 Boni #3: Dynamische Aktivierungs-Matrix (20 Seiten)',
  price: 'KOSTENLOSE'
}, {
  label: '🎁 Boni #4: Anti-Entzündungs-Guide (20 Seiten)',
  price: 'KOSTENLOSE'
}, {
  label: '🎁 Boni #5: Der 360° Fortschritts-Planer (20 Seiten)',
  price: 'KOSTENLOSE'
}, {
  label: '🛡️ 7-Tage-Geld-zurück-Garantie',
  price: 'INKLUSIVE'
}, {
  label: '♾️ Lebenslanger Zugriff & kostenlose Updates',
  price: 'INKLUSIVE'
}];
const trust = [{
  icon: LockIcon,
  label: '100% Sichere Zahlung'
}, {
  icon: ZapIcon,
  label: 'Sofortige Lieferung'
}, {
  icon: ShieldCheckIcon,
  label: '7-Tage-Garantie'
}, {
  icon: CreditCardIcon,
  label: 'Debit / Kreditkarte'
}];
export function ValueStack() {
  return <section id="value" aria-label="Angebotsübersicht" className="border-y border-grape/10 bg-white/70" data-id="element-191" data-mp="1ohbeifik9ilr">
      <div className="mx-auto max-w-2xl px-5 py-12 text-center" style={{
      paddingTop: "13px",
      paddingBottom: "25px"
    }} data-id="element-192" data-mp="2367ssub7nrut">
        <h2 className="font-display text-2xl font-black text-grape sm:text-4xl" data-id="element-193" data-mp="1ycv5cni9pr3n">
          🚀 Verwalten Sie Verletzungen in 30 Tagen mit klinischer Sicherheit
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-plum/60" data-id="element-194" data-mp="2837qohxwpoau">
          Bewerten Sie richtig mit dem Traffic Light System. Progressieren Sie mit dem Load Master
          Protocol. Bauen Sie Prävention mit dem A.R.M.A. Schild. Eine einzige Zahlung,
          lebenslanger Zugriff, alles sofort verfügbar.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-grape/15 bg-cream text-left" data-id="element-195" data-mp="rqj6841vcuuj">
          <div className="flex items-center justify-between border-b border-grape/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-plum/55" data-id="element-196" data-mp="msr5ckj8xye7">
            <span data-id="element-197" data-mp="2rrqwkytq32k5">Was ist inbegriffen</span>
            <span data-id="element-198" data-mp="2rssftqkw6vcy">Preis</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-grape/10 px-5 py-3.5 text-sm" data-id="element-199" data-mp="2vtktcw0srmf1">
              <span className="text-plum/80" data-id="element-200" data-mp="30ui9l328y6dw">{r.label}</span>
              <span className={r.price.startsWith('€') ? 'shrink-0 font-bold text-plum' : 'shrink-0 font-bold text-grape'} data-id="element-201" data-mp="35sjrvlrum1ob">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-col items-center gap-1 bg-lilac-soft px-5 py-6 text-center" data-id="element-202" data-mp="3fi3cowz4g5lt">
            <span className="text-sm font-bold text-plum" style={{
            fontSize: "16px"
          }} data-id="element-203" data-mp="3jj6rrh9chxlz">
              Echter Gesamtwert: <span className="text-plum/40 line-through" data-id="element-204" data-mp="3ojaywgod5fzj">€249</span>
            </span>
            <div className="flex w-full justify-center" style={{
            paddingTop: "9px",
            paddingBottom: "9px"
          }} data-id="element-205" data-mp="3th2zs06zkcfv">
              <span className="relative inline-block font-display leading-none" style={{
              fontFamily: "Montserrat, sans-serif"
            }} data-id="element-206" data-mp="7gf5dh77bnxz">
                {/* Currency symbol — adjust fontSize here */}
                <span className="text-grape-shine absolute right-full top-1/2 -translate-y-1/2 font-black leading-none" style={{
                fontSize: "40px",
                marginRight: "4px",
                fontFamily: "Merriweather, serif"
              }} data-id="element-207" data-mp="3toepkini1dxl">
                  €
                </span>

                {/* Amount — stays centered on the page */}
                <span className="text-grape-shine font-black leading-none" style={{
                fontSize: "70px",
                fontFamily: "Merriweather, serif"
              }} data-id="element-208" data-mp="ggttspfgpj5p">
                  27
                </span>

                {/* Currency code — adjust fontSize here */}
                <span className="absolute left-full top-1/2 -translate-y-1/2 font-bold uppercase leading-none tracking-wide text-grape" style={{
                fontSize: "26px",
                marginLeft: "6px",
                fontWeight: "900",
                fontFamily: "Merriweather, serif"
              }} data-id="element-209" data-mp="18z8ulrw0aqlk">
                  EUR
                </span>
              </span>
            </div>
            <span className="text-xs font-semibold uppercase tracking-wide text-plum/60" data-id="element-210" data-mp="fpaum1jkkywz">
              Einmalzahlung
            </span>
            <span className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-211" data-mp="17ew596ru23v9">
              Die Zahlung wird in Ihrer Landeswährung abgewickelt.
            </span>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-212" data-mp="1cftlhdta8nu4">
          <CTAButton data-id="element-213" data-mp="ylj4xjrfvzz5">Holen Sie sich den Reha-Code 360° jetzt</CTAButton>
        </div>

        <p className="mt-3 text-xs font-semibold text-plum/55" data-id="element-214" data-mp="12ne3ighzjz98">
          Sie sparen €222 (89% RABATT) · Einmalzahlung
        </p>
        

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-215" data-mp="1qcgu4dull2fv">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-216" data-mp="3ftksq4exwtkd">
              <Icon className="h-4 w-4 text-grape" data-id="element-217" data-mp="3awc5hpexpzc9" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}